import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Dialog, Box, FormControl, Select, Button } from "@primer/react";
import { phuHuynhApi } from "../../../api/phuHuynhApi";
import { useCommonContext } from "../../../contexts/common";
import { NotifyHelper, showNotify } from "../../../helpers/toast";
import { IPhuHuynhUpdateInfoRequest } from "../../../models/request/phu-huynh/IPhuHuynhUpdateInfoRequest";
import { useCommonSelectedHook } from "../../../hooks/useCommonSelectedHook";
import { Controller, useForm } from "react-hook-form";
import { FormGroup, Grid } from "semantic-ui-react";
import MyButton from "../../../components/ui/button/Button";
import TextInput from "../../../components/ui/text-input";
import ComboboxQuocTich from "../../../components/combobox-quoctich";
import Modal from "../../../components/ui/modal";
import ComboboxQuanHe from "../../../components/combobox-quanhe/ComboboxQuanHe";
import ComboboxTrangThaiPhuHuynh from "../../../components/combobox-trangthai-phuhuynh";
import ComboboxChienDich from "../../../components/combobox-chiendich/ComboboChiendich";
import ComboboxGioiTinh from "../../../components/combobox-gioitinh";
import { useParams } from "react-router-dom";


interface PhuHuynhInsertModalProps {
  id: number;
  value?: number;
  height?: number;
  phuHuynh?: any;
  onClose: () => void;
  onSuccess: () => void;
}

const PhuHuynhInsertModal = (props: PhuHuynhInsertModalProps) => {
  const { nam_hoc, dm_coso_id } = useCommonSelectedHook();
  const { translate } = useCommonContext();
  const [isSaving, setIsSaving] = useState(false);
  const [formData, setFormData] = useState<IPhuHuynhUpdateInfoRequest>({
    id: 0,
    ho_ten: "",
    dm_coso_id:1,
    email: "",
    dien_thoai: "",
    dia_chi_thuong_tru: "",
    dm_quanhe_id: 0,
    nghe_nghiep: "",
    noi_lam_viec: "",
    ts_phuhuynh_adm_status_id: 0,
    dm_chiendich_id: 0,
    dm_quoctich_id: 0,
    dm_gioitinh_id: 0,
    chung_minh_thu: "",
    ngay_cap_chung_minh_thu: undefined,
    noi_cap_chung_minh_thu: "",
    ngay_sinh: undefined,
  });

  const {
    register,
    handleSubmit,
    clearErrors,
    reset,
    setError,
    control,
    watch,
    trigger,
    formState: { errors },
  } = useForm<IPhuHuynhUpdateInfoRequest>({
    mode: "all",
    defaultValues: formData,
  });

  useEffect(() => {
    debugger
    if (props.id) {
      handleGetDetail(props.id);
    }
  }, [props.id]);


  const handleGetDetail = async (id: number) => {
    if (id && id > 0) {
      debugger
      const res = await phuHuynhApi.getById(id);
      if (res.is_success) {
        const data = res.data;
        setFormData({
          id: data.id,
          dm_coso_id: data.dm_coso_id,
          ho_ten: data.ho_ten,
          email: data.email,
          dien_thoai: data.dien_thoai,
          dia_chi_thuong_tru: data.dia_chi_thuong_tru,
          dm_quanhe_id: data.dm_quanhe_id,
          nghe_nghiep: data.nghe_nghiep,
          noi_lam_viec: data.noi_lam_viec,
          ts_phuhuynh_adm_status_id: data.ts_phuhuynh_adm_status_id,
          dm_chiendich_id: data.dm_chiendich_id,
          dm_quoctich_id: data.dm_quoctich_id,
          dm_gioitinh_id: data.dm_gioitinh_id,
          chung_minh_thu: data.chung_minh_thu,
          ngay_cap_chung_minh_thu: data.ngay_cap_chung_minh_thu,
          noi_cap_chung_minh_thu: data.noi_cap_chung_minh_thu,
          ngay_sinh: data.ngay_sinh,
        });
        reset(data);
      }
    }
  };

  const handleSaveChanges = async (data: any) => {
    setIsSaving(true);
    const formDataSubmit: IPhuHuynhUpdateInfoRequest = {
      id: data.id,
      dm_coso_id: 1,
      ho_ten: data.ho_ten ?? "",
      email: data.email ?? "",
      dien_thoai: data.dien_thoai ?? "",
      dia_chi_thuong_tru: data.dia_chi_thuong_tru ?? "",
      dm_quanhe_id: data.dm_quanhe_id ?? 0,
      nghe_nghiep: data.nghe_nghiep ?? "",
      noi_lam_viec: data.noi_lam_viec ?? "",
      ts_phuhuynh_adm_status_id: data.ts_phuhuynh_adm_status_id ?? 0,
      dm_chiendich_id: data.dm_chiendich_id ?? 0,
      dm_quoctich_id: data.dm_quoctich_id ?? 0,
      dm_gioitinh_id: data.dm_gioitinh_id ?? 0,
      chung_minh_thu: data.chung_minh_thu ?? "",
      ngay_cap_chung_minh_thu: data.ngay_cap_chung_minh_thu ?? undefined,
      noi_cap_chung_minh_thu: data.noi_cap_chung_minh_thu ?? "",
      ngay_sinh: data.ngay_sinh ?? undefined,
    };

    const isValid = await trigger();
    if (!isValid) {
      setIsSaving(false);
      return;
    }

    let res;
    if (formData.id > 0) {
      // Cập nhật học sinh
      if (formData.id !== 0) {
        const resHS = await phuHuynhApi.getById(formData.id);
        if (resHS.is_success && resHS.data && formData.id !== resHS.data.id) {
          NotifyHelper.Error("Mã phụ huynh này đã tồn tại");
          setIsSaving(false);
          return;
        }
      }
      res = await phuHuynhApi.updateInfo(formDataSubmit);
    } else {
      // Thêm mới học sinh
      const resHS = await phuHuynhApi.getById(formData.id);
      if (resHS.is_success && resHS.data) {
        NotifyHelper.Error("Mã phụ huynh này đã tồn tại");
        setIsSaving(false);
        return;
      }
      debugger;
      res = await phuHuynhApi.insertInfo(formDataSubmit);
    }

    if (res.is_success) {
      NotifyHelper.Success(
        formData.id > 0 ? "Cập nhật thành công" : "Thêm mới thành công"
      );
      props.onSuccess();
    } else {
      NotifyHelper.Error(res.message ?? "");
    }
    setIsSaving(false);
  };

  return (
    <Modal
      isOpen
      onClose={props.onClose}
      width={"1000px"}
      title={formData.id > 0 ? "Update" : "Add new"}
    >
      <Box className="container" p={0}>
        <form onSubmit={handleSubmit(handleSaveChanges)}>
          <div className="row">
            <div className="col-md-12" style={{ paddingTop: "10px" }}>
              <div className="row">
                <div className="col-md-4 mb-3">
                  <FormControl>
                    <FormControl.Label>Trạng thái</FormControl.Label>
                    <Controller
                      name="ts_phuhuynh_adm_status_id"
                      control={control}
                      rules={{ required: "Vui lòng chọn trạng thái" }}
                      render={({ field }) => (
                        <ComboboxTrangThaiPhuHuynh
                          value={field.value}
                          onValueChanged={(value) => {
                            field.onChange(value);
                            setFormData((prev) => ({
                              ...prev,
                              ts_phuhuynh_adm_status_id: value,
                            }));
                          }}
                        />
                      )}
                    />
                    {errors.ts_phuhuynh_adm_status_id && (
                      <FormControl.Validation variant="error">
                        {errors.ts_phuhuynh_adm_status_id.message}
                      </FormControl.Validation>
                    )}
                  </FormControl>
                </div>
                <div className="col-md-4 mb-3">
                  <FormControl>
                    <FormControl.Label>Quan hệ</FormControl.Label>
                    <Controller
                      name="dm_quanhe_id"
                      control={control}
                      rules={{ required: "Vui lòng chọn quan hệ" }}
                      render={({ field }) => (
                        <ComboboxQuanHe
                          value={field.value}
                          onValueChanged={(value) => {
                            field.onChange(value);
                            setFormData((prev) => ({
                              ...prev,
                              dm_quanhe_id: value,
                            }));
                          }}
                        />
                      )}
                    />
                    {errors.dm_quanhe_id && (
                      <FormControl.Validation variant="error">
                        {errors.dm_quanhe_id.message}
                      </FormControl.Validation>
                    )}
                  </FormControl>
                </div>
                <div className="col-md-4 mb-3">
                  <FormControl>
                    <FormControl.Label>Giới tính</FormControl.Label>
                    <Controller
                      name="dm_gioitinh_id"
                      control={control}
                      rules={{ required: "Vui lòng chọn giới tính" }}
                      render={({ field }) => (
                        <ComboboxGioiTinh
                          value={field.value}
                          onValueChanged={(value) => {
                            field.onChange(value);
                            setFormData((prev) => ({
                              ...prev,
                              dm_gioitinh_id: value,
                            }));
                          }}
                        />
                      )}
                    />
                    {errors.dm_gioitinh_id && (
                      <FormControl.Validation variant="error">
                        {errors.dm_gioitinh_id.message}
                      </FormControl.Validation>
                    )}
                  </FormControl>
                </div>
                <div className="col-md-4 mb-3">
                  <FormControl>
                    <FormControl.Label>Họ tên</FormControl.Label>
                    <TextInput
                      block
                      name="ho_ten"
                      register={register}
                      errors={errors}
                      required
                      validateMessage="Vui lòng điền họ tên"
                    />
                  </FormControl>
                </div>
                <div className="col-md-4 mb-3">
                  <FormControl>
                    <FormControl.Label>Điện thoại</FormControl.Label>
                    <TextInput
                      block
                      name="dien_thoai"
                      register={register}
                      errors={errors}
                      required
                      validateMessage="Vui lòng điền số điện thoại"
                    />
                  </FormControl>
                </div>
                <div className="col-md-4 mb-3">
                  <FormControl>
                    <FormControl.Label>Email</FormControl.Label>
                    <TextInput
                      block
                      name="email"
                      register={register}
                      errors={errors}
                      required
                      validateMessage="Vui lòng điền email"
                    />
                  </FormControl>
                </div>
                <div className="col-md-4 mb-3">
                  <FormControl>
                    <FormControl.Label>Quốc tịch</FormControl.Label>
                    <Controller
                      name="dm_quoctich_id"
                      control={control}
                      rules={{ required: "Vui lòng chọn quốc tịch" }}
                      render={({ field }) => (
                        <ComboboxQuocTich
                          value={field.value}
                          onValueChanged={(value) => {
                            field.onChange(value);
                            setFormData((prev) => ({
                              ...prev,
                              dm_quoctich_id: value,
                            }));
                          }}
                        />
                      )}
                    />
                    {errors.dm_quoctich_id && (
                      <FormControl.Validation variant="error">
                        {errors.dm_quoctich_id.message}
                      </FormControl.Validation>
                    )}
                  </FormControl>
                </div>
                <div className="col-md-8 mb-3">
                  <FormControl>
                    <FormControl.Label>Địa chỉ thường trú</FormControl.Label>
                    <TextInput
                      block
                      name="dia_chi_thuong_tru"
                      register={register}
                      errors={errors}
                      required
                      validateMessage="Vui lòng điền địa chỉ"
                    />
                  </FormControl>
                </div>
              
                <div className="col-md-4 mb-3">
                  <FormControl>
                    <FormControl.Label>CMND/CCCD</FormControl.Label>
                    <TextInput
                      block
                      name="chung_minh_thu"
                      register={register}
                      errors={errors}
                      required
                      validateMessage="Vui lòng điền CMND/CCCD"
                    />
                  </FormControl>
                </div>
                <div className="col-md-4 mb-3">
                  <FormControl>
                    <FormControl.Label>Ngày cấp CMND/CCCD</FormControl.Label>
                    <TextInput
                      block
                      type="date"
                      value={
                        formData.ngay_cap_chung_minh_thu instanceof Date
                          ? formData.ngay_cap_chung_minh_thu
                              .toISOString()
                              .split("T")[0]
                          : "" // Nếu không phải là Date, trả về chuỗi rỗng
                      }
                      onChange={(e) => {
                        const value = e.target.value;
                        setFormData((prev) => ({
                          ...prev,
                          ngay_cap_chung_minh_thu: value
                            ? new Date(value)
                            : null, // Chuyển đổi giá trị sang Date
                        }));
                        //  trigger("ngay_nhap_hoc");
                      }}
                      name="ngay_cap_chung_minh_thu"
                      register={register}
                      errors={errors}
                      required
                      validateMessage="Vui lòng điền ngày cấp CMND/CCCD"
                    />
                  </FormControl>
                </div>
                <div className="col-md-4 mb-3">
                  <FormControl>
                    <FormControl.Label>Nơi cấp CMND/CCCD</FormControl.Label>
                    <TextInput
                      block
                      name="noi_cap_chung_minh_thu"
                      register={register}
                      errors={errors}
                      required
                      validateMessage="Vui lòng điền nơi cấp CMND/CCCD"
                    />
                  </FormControl>
                </div>
                <div className="col-md-4 mb-3">
                  <FormControl>
                    <FormControl.Label>Nghề nghiệp</FormControl.Label>
                    <TextInput
                      block
                      name="nghe_nghiep"
                      register={register}
                      errors={errors}
                      required
                      validateMessage="Vui lòng điền nghề nghiệp"
                    />
                  </FormControl>
                </div>
                <div className="col-md-8 mb-3">
                  <FormControl>
                    <FormControl.Label>Nơi làm việc</FormControl.Label>
                    <TextInput
                      block
                      name="noi_lam_viec"
                      register={register}
                      errors={errors}
                      required
                      validateMessage="Vui lòng điền nơi làm việc"
                    />
                  </FormControl>
                </div>
                <div className="col-md-12 mb-3">
                  <FormControl>
                    <FormControl.Label>Chiến dịch</FormControl.Label>
                    <Controller
                      name="dm_chiendich_id"
                      control={control}
                      rules={{ required: "Vui lòng chọn chiến dịch" }}
                      render={({ field }) => (
                        <ComboboxChienDich
                          value={field.value}
                          onValueChanged={(value) => {
                            field.onChange(value);
                            setFormData((prev) => ({
                              ...prev,
                              dm_chiendich_id: value,
                            }));
                          }}
                        />
                      )}
                    />
                    {errors.dm_chiendich_id && (
                      <FormControl.Validation variant="error">
                        {errors.dm_chiendich_id.message}
                      </FormControl.Validation>
                    )}
                  </FormControl>
                </div>             
                <div
                  className="col-md-12 fixed-bottom"
                  style={{
                    paddingTop: "20px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <MyButton
                    text="Base.Label.Save"
                    variant="primary"
                    type="submit"
                    isLoading={isSaving}
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
      </Box>
    </Modal>
  );
};

export default PhuHuynhInsertModal;
